<template>
    <div :class="['flex tabs', classes]">
        <div v-for="(tab, key) in tabs"
             :class="['border-b-8 mr-6 pb-2 cursor-pointer text-sm tabs__tab border-transparent tab', tab.active ? 'active' : '']"
             @click="switchTab(key)">
            {{ $__(tab.translationKey) }}
        </div>
    </div>
</template>

<script>
    export default {
        props: ['tabs', 'classes'],
        methods: {
            switchTab(key) {
                this.$emit('switchTab', key)
            }
        },
    }
</script>
